import React from 'react';

import style from './Login.module.css';

import icons from '../../icons';
import urls from '../../urls';

import Lottie from 'lottie-react';
import verification_animation from '../../lottieAnimations/email_verification_animation.json';

import { db, auth, googleAuthProvider } from "../../firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, sendEmailVerification, signOut } from "firebase/auth";
import { collection, doc, getDocs, query, setDoc, updateDoc, where, increment, arrayUnion, getDoc } from "firebase/firestore";
import { AppContext } from '../../AppContext';
import Banner from '../Banner/Banner';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

// https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.coursework.me

const getDefaultTermsSeparator = () => new Date((new Date()).getMonth() > 5 ? (new Date()).getFullYear() + 1 : (new Date()).getFullYear(), 0, 31);

export default class Login extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            classes: [],
            users: {},
            usernameOrEmail: "",
            password: "",
            swiper: undefined,
            selectedSchool: undefined,
            invitedBy: props.loginData?.invitedBy,
            selectedClass: props.loginData?.class?.[0] ?? 1,
            selectedClassSection: props.loginData?.class?.substring(1) ?? undefined,
            registrationPassword: "",
            registrationConfirmPassword: "",
            registrationEmail: "",
            registrationUsername: "",
            signingUp: false,
            schoolRegion: "",
            schoolCity: "",
            schoolCode: "",
            schoolName: "",
            searchedSchools: [],
            showSchoolSearch: false,
            schoolNotFoundPopup: { show: false, report: "", loading: false },
            schoolChoiceSwiper: null,
            pendingVerification: false,
            searchingSchool: false,
            selectedSignupMethod: "email",
            loginPasswordSee: false,
            registrationPasswordSee: false,
            registrationConfirmPasswordSee: false,
        };

        this.getErrorMessage = code => {
            switch (code.replace("auth/", "")) {
                case "user-not-found":
                    return "Nessun utente trovato per questo account";
                case "too-many-requests":
                    return "Hai eseguito troppe richieste da questo dispositivo. Attendi.";
                case "wrong-password":
                    return "La password non è corretta, o l'account è registrato con Google";
                case "invalid-email":
                    return "L'indirizzo email inserito non è valido";
                case "email-already-in-use":
                    return "Questo indirizzo email è già associato a un altro account";
                case "weak-password":
                    return "La password dev'essere lunga almeno 6 caratteri";
                default: 
                    return "Qualcosa non ha funzionato, riprova più tardi";
            }
        }

        this.getSchool = (slideNext=false) => {
            this.setState({ searchingSchool: true });
            fetch(urls.getSchool, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ region: this.state.schoolRegion?.trim(), city: this.state.schoolCity?.trim(), schoolCode: this.state.schoolCode?.trim(), schoolName: this.state.schoolName?.trim() })
            }).then(res => res.json()).then(res =>{
                this.setState({ selectedSchool: undefined, searchedSchools: res, searchingSchool: false });
                if (slideNext)
                    this.state.schoolChoiceSwiper.slideNext();
            });
        };

        this.sendSchoolNotFoundReport = async () => {
            if (!this.state.usernameOrEmail) {
                document.querySelector("#school-report-error-message").textContent = "Inserisci un indirizzo email!";
                document.querySelector("#school-report-error").style.display = "block";
                return
            }
            
            this.setState(oldState => ({ schoolNotFoundPopup: { show: true, loading: true, report: oldState.schoolNotFoundPopup.report } }));
            await fetch(urls.bugReport, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ text: `School not found - ${this.state.schoolNotFoundPopup.report}`, user: { email: this.state.usernameOrEmail } })
            });

            this.setState({ schoolNotFoundPopup: { show: false, report: "", loading: false }, usernameOrEmail: "" });
        };

        this.login = () => {
            if (this.state.users !== null && this.state.users !== undefined) {
                this.setState({ signingUp: true });
                
            signInWithEmailAndPassword(auth, this.state.usernameOrEmail, this.state.password)
                .then(() => this.context.setPage({ page: "home" }))
                .catch(error => {
                    document.querySelector("#login-error-message").textContent = this.getErrorMessage(error.code);
                    document.querySelector("#login-error").style.display = "block";
                    document.querySelector("#login-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                    this.setState({ signingUp: false });
                    
                });
            }
        }

        this.googleSignIn = async () => {
            this.setState({ signingUp: true });
            signInWithPopup(auth, googleAuthProvider)
                .then(async result => {
                    if (result._tokenResponse.isNewUser) {                        
                        await result.user.delete();
                        await signOut(auth);
                        document.querySelector("#login-error-message").textContent = "Registrati prima di effettuare il login";
                        document.querySelector("#login-error").style.display = "block";
                        document.querySelector("#login-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                        this.setState({ signingUp: false });
                        return;
                    };

                    this.context.setPage({ page: "home" });
                    this.setState({ signingUp: false });
                }).catch(error => {
                    // Handle Errors here.
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    // The email of the user's account used.
                    // const email = error.customData.email;
                    // The AuthCredential type that was used.
                    const credential = GoogleAuthProvider.credentialFromError(error);
                    // ...
                    console.warn(errorCode, errorMessage, credential);
                    
                    document.querySelector("#login-error-message").textContent = this.getErrorMessage(error.code);
                    document.querySelector("#login-error").style.display = "block";
                    document.querySelector("#login-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                    this.setState({ signingUp: false });
                });
        };

        this.googleSignUp = async () => {
            if (
                !this.state.signingUp &&
                typeof this.state.selectedClass != 'undefined' && typeof this.state.selectedClassSection != 'undefined' &&
                this.state.selectedSchool !== "" && this.state.selectedSchool
            ) {
                this.setState({ signingUp: true });
                
                signInWithPopup(auth, googleAuthProvider)
                    .then(async result => {
                        const user = result.user;

                        if (result._tokenResponse?.isNewUser) {
                            const school = await (await getDocs(query(collection(db, "schools"), where("id", "==", this.state.selectedSchool["miur:CODICESCUOLA"])))).docs;
                            if (!school || school?.length === 0)
                                await setDoc(doc(db, "schools", this.state.selectedSchool["miur:CODICESCUOLA"]), {
                                    id: this.state.selectedSchool["miur:CODICESCUOLA"],
                                    name: this.state.selectedSchool["miur:DENOMINAZIONESCUOLA"],
                                    presidents: {}
                                });
                            
                            let classInstance;
                            if (school) 
                                classInstance = await (await getDocs(query(collection(db, `schools/${this.state.selectedSchool["miur:CODICESCUOLA"]}/classes/`), where("id", "==", this.state.selectedClass + this.state.selectedClassSection)))).docs;
                            
                            if (!school || !classInstance || classInstance?.length === 0) 
                                await setDoc(doc(db, `schools/${this.state.selectedSchool["miur:CODICESCUOLA"]}/classes`, this.state.selectedClass + this.state.selectedClassSection), {
                                    id: this.state.selectedClass + this.state.selectedClassSection,
                                    calendar: {
                                        holidays: [],
                                        termsSeparator: getDefaultTermsSeparator().toString(),
                                    },
                                    presidents: {}
                                });
                            
                            // newUser
                            const newUser = { 
                                id: user.uid,
                                emailVerified: true,
                                providerId: result.providerId,
                                profilePicture: user.photoURL,
                                username: user.displayName ?? "", 
                                email: user.email, 
                                class: this.state.selectedClass + this.state.selectedClassSection, 
                                school: this.state.selectedSchool["miur:CODICESCUOLA"],
                                notificateSummarizeNextDayEvents: !this.checkIOS(),
                                notificateClassPresidentAnnouncements: !this.checkIOS(),
                                notificateSchoolPresidentAnnouncements: !this.checkIOS(),
                            };

                            await setDoc(doc(db, "users", user.uid), newUser);

                            if (this.state.invitedBy) {
                                const inviter = (await getDoc(doc(db, `users/${this.state.invitedBy}`))).data();
                                if (!inviter?.invitedFriendsEmails?.includes(user.email)) {
                                    await updateDoc(doc(db, `users/${this.state.invitedBy}`), {
                                        invitedFriends: increment(1),
                                        invitedFriendsEmails: arrayUnion(user.email)
                                    });
                                }
                            }

                            try {
                                await fetch(urls.signup, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        user: newUser,
                                        newSchool: (!school || school?.length === 0) ? {
                                            id: this.state.selectedSchool["miur:CODICESCUOLA"],
                                            name: this.state.selectedSchool["miur:DENOMINAZIONESCUOLA"],
                                            presidents: {},
                                        } : false,  
                                        newClass: !classInstance || classInstance?.length === 0 ? {
                                            id: this.state.selectedClass + this.state.selectedClassSection,
                                            calendar: {
                                                holidays: [],
                                                termsSeparator: getDefaultTermsSeparator().toString(),
                                            },
                                            presidents: {},
                                        } : false,  
                                    })
                                });
                            } catch (err) {}
                                
                            this.context.setUser(newUser);
                        }
                        
                        this.setState({ signingUp: false });
                        this.context.setPage({ page: "home" });
                        window.location.reload();
                    }).catch(error => {
                        document.querySelector("#registration-error-message").textContent = this.getErrorMessage(error.code);
                        document.querySelector("#registration-error").style.display = "block";
                        document.querySelector("#registration-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                        this.setState({ signingUp: false });
                    });
            } else {
                document.querySelector("#registration-error-message").textContent = this.state.selectedSignupMethod === "google" ? "Specifica scuola e classe frequentate" : "Riempi tutti i campi!";
                document.querySelector("#registration-error").style.display = "block";
                document.querySelector("#registration-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                this.setState({ signingUp: false });                
            }
        };

        this.checkIOS = () => {
            if (navigator.standalone) {
                return false;
            }
        
            const ua = window.navigator.userAgent;
            const webkit = !!ua.match(/WebKit/i);
            const isIPad = !!ua.match(/iPad/i);
            const isIPhone = !!ua.match(/iPhone/i)
            const isIOS = isIPad || isIPhone;
            const isSafari = isIOS && webkit && !ua.match(/CriOS/i);
        
            return isIOS && isSafari;
        };

        this.checkLoggedIn = () => {
            if (auth.currentUser?.emailVerified && !this.state.signingUp) this.context.setPage({ page: "home" });
        }

        this.signup = async () => {
            if (
                !this.state.signingUp &&
                this.state.registrationEmail !== "" &&
                this.state.registrationUsername !== "" &&
                this.state.registrationConfirmPassword !== "" &&
                this.state.registrationPassword !== "" &&
                typeof this.state.selectedClass != 'undefined' && typeof this.state.selectedClassSection != 'undefined' &&
                this.state.selectedSchool !== "" && this.state.selectedSchool &&
                this.state.registrationPassword === this.state.registrationConfirmPassword &&
                this.state.registrationEmail.match(/^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/)
            ) {
                this.setState({ signingUp: true });
                
                createUserWithEmailAndPassword(auth, this.state.registrationEmail.trim(), this.state.registrationPassword.trim())
                    .then(async userCredential => {
                        const user = userCredential.user;

                        const school = await getDocs(query(collection(db, "schools"), where("id", "==", this.state.selectedSchool["miur:CODICESCUOLA"]))).docs;
                        if (!school || school?.length === 0)
                            await setDoc(doc(db, "schools", this.state.selectedSchool["miur:CODICESCUOLA"]), {
                                id: this.state.selectedSchool["miur:CODICESCUOLA"],
                                name: this.state.selectedSchool["miur:DENOMINAZIONESCUOLA"],
                                presidents: {},
                            });

                        let classInstance;
                        if (school) 
                            classInstance = await (await getDocs(query(collection(db, `schools/${this.state.selectedSchool["miur:CODICESCUOLA"]}/classes/`), where("id", "==", this.state.selectedClass + this.state.selectedClassSection)))).docs;
                            
                        if (!school || !classInstance || classInstance?.length === 0) 
                            await setDoc(doc(db, `schools/${this.state.selectedSchool["miur:CODICESCUOLA"]}/classes`, this.state.selectedClass + this.state.selectedClassSection), {
                                id: this.state.selectedClass + this.state.selectedClassSection,
                                calendar: {
                                    holidays: [],
                                    termsSeparator: getDefaultTermsSeparator().toString(),
                                },
                                presidents: {},
                            });

                        const newUser = { 
                            id: user.uid, 
                            emailVerified: false,
                            providerId: "email",
                            username: user.displayName ?? this.state.registrationUsername.trim(), 
                            email: user.email, 
                            class: this.state.selectedClass + this.state.selectedClassSection, 
                            school: this.state.selectedSchool["miur:CODICESCUOLA"],
                            notificateSummarizeNextDayEvents: !this.checkIOS(),
                            notificateClassPresidentAnnouncements: !this.checkIOS(),
                            notificateSchoolPresidentAnnouncements: !this.checkIOS(),
                        }

                        await setDoc(doc(db, "users", user.uid), newUser);
                        await sendEmailVerification(user);

                        if (this.state.invitedBy) {
                            const inviter = (await getDoc(doc(db, `users/${this.state.invitedBy}`))).data();
                            if (!inviter?.invitedFriendsEmails?.includes(user.email)) {
                                await updateDoc(doc(db, `users/${this.state.invitedBy}`), {
                                    invitedFriends: increment(1),
                                    invitedFriendsEmails: arrayUnion(user.email)
                                });
                            }
                        }

                        try {
                            await fetch(urls.signup, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    user: newUser,
                                    newSchool: (!school || school?.length === 0) ? {
                                        id: this.state.selectedSchool["miur:CODICESCUOLA"],
                                        name: this.state.selectedSchool["miur:DENOMINAZIONESCUOLA"],
                                        presidents: {},
                                    } : false,  
                                    newClass: !classInstance || classInstance?.length === 0 ? {
                                        id: this.state.selectedClass + this.state.selectedClassSection,
                                        calendar: {
                                            holidays: [],
                                            termsSeparator: getDefaultTermsSeparator().toString(),
                                        },
                                        presidents: {},
                                    } : false,  
                                })
                            });
                        } catch (err) {}

                        this.context.setUser(newUser);

                        console.log("<Login> Signup done");
                        this.setState({ signingUp: false });
                        
                        this.context.setPage({ page: "emailVerification" });
                    })
                    .catch(error => {
                        document.querySelector("#registration-error-message").textContent = this.getErrorMessage(error.code);
                        document.querySelector("#registration-error").style.display = "block";
                        document.querySelector("#registration-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });

                        this.setState({ signingUp: false });
                    });
            } else if (this.state.registrationPassword !== this.state.registrationConfirmPassword) {
                document.querySelector("#registration-error-message").textContent = "Le password inserite non coincidono!";
                document.querySelector("#registration-error").style.display = "block";
                document.querySelector("#registration-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                this.setState({ signingUp: false });                
            } else if (!this.state.registrationEmail.match(/^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/)) {
                document.querySelector("#registration-error-message").textContent = "Inserisci un indirizzo email valido!";
                document.querySelector("#registration-error").style.display = "block";
                document.querySelector("#registration-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                this.setState({ signingUp: false });
            } else {
                document.querySelector("#registration-error-message").textContent = "Riempi tutti i campi!";
                document.querySelector("#registration-error").style.display = "block";
                document.querySelector("#registration-error").scrollIntoView({ block: 'start',  behavior: 'smooth' });
                this.setState({ signingUp: false });
            }
        } 
    }

    async componentDidMount() {
        if (this.props.loginData?.school) {
            fetch(urls.getSchool, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ schoolCode: this.props.loginData?.school })
            }).then(res => res.json()).then(res =>{
                this.setState({ selectedSchool: res[0], searchedSchools: res });
                document.querySelector("#signup-page").scrollIntoView({ block: 'start',  behavior: 'smooth' });
            });
        }

        window.addEventListener('online', () => this.setState({ offline: !navigator.onLine }));
        window.addEventListener('offline', () => this.setState({ offline: !navigator.onLine }));
    }

    componentWillUnmount() {
        window.removeEventListener('online', () => this.setState({ offline: !navigator.onLine }));
        window.removeEventListener('offline', () => this.setState({ offline: !navigator.onLine }));
    }

    render() {
        // if (this.state.offline || this.state.data.offline) return <Redirect to="/offline" />;
        if (this.state.pendingVerification) return <main className={style.main }>
            <Lottie 
                style={{ marginTop: "3rem" }}
                loop={ true }
                autoplay={ true }
                animationData={ verification_animation }
                height={ 300 }
                width={ 300 }
            />
            <h2 style={{ margin: "2rem 1rem", fontSize: "1.2rem" }}>Benvenuto su <span style={{ color: "var(--orange)" }}>SchoolDiary</span>!</h2><h3 style={{ margin: "-1rem 1rem", fontSize: "1rem" }}>Per completare la registrazione, conferma la tua identità cliccando sul link che ti abbiamo inviato all'indirizzo email <span style={{ color: "var(--orange)" }}>{ this.state.registrationEmail }</span></h3>
            { this.state.registrationEmail?.includes("@gmail.com") && <div onClick={ () => window.open("https://mail.google.com/mail") } style={{ marginTop: "3.5rem" }} className={ style.button }>
                <img src={ icons.email_icon }></img>
                <h3>APRI GMAIL</h3>
            </div>  }
        </main>
        return <>
            <main className={ style.main } onClick={ e => {
                this.setState({ schoolNotFoundPopup: { show: false } });
                // if (this.state.schoolNotFoundPopup.show) this.setState({ showSchoolSearch: false, selectedSchool: undefined, searchedSchools: [], schoolCity: "", schoolCode: "", schoolName: "" });
                e.stopPropagation();
            } }>
                { this.state.offlineNotAvailable && (
                    <div className={ style.offline }>
                        <h4>Il backup dei dati per la modalità offline non è disponibile sul tuo dispositivo</h4>
                        <div className={ style.okBtn } onClick={ () => {
                            this.setState({ offlineNotAvailable: false });
                        } }>OK</div>
                    </div>
                ) }
                <div className={ style.page }>
                    {/* <Banner /> */}
                    <header>
                        <div className={ style.logo }><img alt="" src={ icons.logo_icon } /></div>
                        <h2 className={ style.appHeader }>School<span>Diary</span></h2>
                        <h3 className={ style.slogan }>Il tuo diario, condiviso con la classe, a portata di un <span>click</span></h3>
                    </header>
                    <section>
                        <div className={ style.actionBtn } onClick={ () => { document.querySelector("#login-page").scrollIntoView({ block: 'start',  behavior: 'smooth' }); } }>
                            VAI AL LOGIN
                        </div>
                    </section>
                </div>
                <div className={ style.page } id="login-page">
                    <h3 className={ style.loginHeader }>LOGIN</h3>
                    <div className={ style.error } id="login-error">
                        <h2 id="login-error-message">Login non riuscito, controlla le credenziali</h2>
                    </div>
                    <div className={ style.loginItem }>
                        <img alt="" src={ icons.email_orange_icon } />
                        <input name="login-email" id="login-email" placeholder="Email" type="email" value={ this.state.usernameOrEmail } onChange={ (event) => {
                            this.setState({ usernameOrEmail: event.target.value });
                            document.querySelector("#login-error").style.display = "none";
                        } }></input>
                    </div>
                    <div className={ style.loginItem }>
                        <img alt="" src={ icons.lock_icon } />
                        <input name="login-psw" id="login-psw" placeholder="Password" type={ this.state.loginPasswordSee ? "text" : "password" } value={ this.state.password } onChange={ (event) => {
                            this.setState({ password: event.target.value });
                            document.querySelector("#login-error").style.display = "none";
                        } }></input>
                        <img alt="" src={ this.state.loginPasswordSee ? icons.visibility_off_icon : icons.visibility_icon } onClick={ () => this.setState(({ loginPasswordSee: oldLoginPasswordSee }) => ({ loginPasswordSee: !oldLoginPasswordSee })) }></img>
                    </div>
                    <div className={ style.loginBtn } onClick={ this.login }>{ this.state.signingUp ? <div className={ style.spinner }></div> : "LOGIN" }</div>
                    <div className={ style.googleBtn } onClick={ this.googleSignIn }>{ 
                        this.state.signingUp ? <div className={ style.spinner } style={{ margin: "1rem auto" }}></div> 
                        : <>
                            <img src={ icons.google_icon }></img>
                            <h3>LOGIN CON GOOGLE</h3>
                        </> }</div>
                    <div className={ style.goToSignupBtn } style={{ marginBottom: "-.75rem" }}>Non hai un account? <span onClick={ () => { document.querySelector("#signup-page").scrollIntoView({ block: 'start',  behavior: 'smooth' }); } }>Registrati</span></div>
                    <div className={ style.goToSignupBtn }><span onClick={ () => this.context.setPage({ page: "recoverPassword" }) }>Password dimenticata?</span></div>
                </div>
                <div className={ [style.page, style.scrollable].join(" ") } id="signup-page">
                    <h3 className={ style.loginHeader }>REGISTRAZIONE</h3>
                    <div className={ style.error } id="registration-error">
                        <h2 id="registration-error-message">Questa email è già in uso!</h2>
                    </div>
                    <div className={ style.modal } style={{ transform: this.state.schoolNotFoundPopup.show ? "translate(-50%, 0)" : "translate(-50%, -999%)" }} onClick={ e => e.stopPropagation() }>
                        <h3 className={ style.modalHeader } style={{ marginBottom: ".5rem" }} onClick={ () => this.setState({ schoolNotFoundPopup: { show: false, report: "", loading: false } }) }>SEGNALA PROBLEMA</h3>
                        <h4 style={{ textAlign: "center", marginLeft: "1rem", marginRight: "1rem", fontSize: ".8rem", marginTop: "0" }}>Non trovi la tua scuola? Prova a cercare solo il nome, cancellando ad esempio "Liceo", "Itis" o simili o solo parte del nome, ad esempio "Cesare" o "Giulio" invece di "Giulio Cesare".<br></br>Assicurati che non ci siano doppi spazi tra le parole.<br></br>Ancora nessun risultato? Segnalalo specificando il nome della tua scuola e un'email a cui inviarti eventuali aggiornamenti!</h4>
                        <div className={ style.error } id="school-report-error">
                            <h2 id="school-report-error-message">Inserisci un indirizzo email!</h2>
                        </div>
                        <div className={ style.signupItem }>
                            <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                            <input name="school-not-found" id="school-not-found" placeholder="Città e nome scuola" type="text" value={ this.state.schoolNotFoundPopup.report } onChange={ event => this.setState({ schoolNotFoundPopup: { report: event.target.value, show: true, loading: false } }) }></input>
                        </div>
                        <div className={ style.signupItem }>
                            <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                            <input name="school-not-found-email" id="school-not-found-email" placeholder="Email" type="email" value={ this.state.usernameOrEmail } onChange={ event => {
                                this.setState({ usernameOrEmail: event.target.value });
                                document.querySelector("#school-report-error").style.display = "none";
                            } }></input>
                        </div>
                        <div className={ style.signupBtn } onClick={ this.sendSchoolNotFoundReport }>{ this.state.schoolNotFoundPopup.loading ? <div className={ style.spinner }></div> : "INVIA" }</div>
                    </div>
                    <Swiper onSwiper={ swiper => this.setState({ schoolChoiceSwiper: swiper }) }>
                        <SwiperSlide>
                            <div className={ style.signupMethodChoice }>
                                <div className={ style.signupMethodOption } 
                                    style={{ backgroundColor: this.state.selectedSignupMethod === "email" ? "rgba(31, 154, 255, 0.5)" : "rgb(70, 70, 69)" }} 
                                    onClick={ () => {
                                        this.setState({ selectedSignupMethod: "email" });
                                        document.querySelector("#registration-error-message").textContent = "";
                                        document.querySelector("#registration-error").style.display = "none";
                                    } }>
                                        <img src={ icons.email_orange_icon }></img>
                                        <h3>EMAIL</h3>
                                </div>
                                <div className={ style.signupMethodOption } 
                                    style={{ backgroundColor: this.state.selectedSignupMethod === "google" ? "rgba(31, 154, 255, 0.5)" : "rgb(70, 70, 69)" }} 
                                    onClick={ () => {
                                        this.setState({ selectedSignupMethod: "google" });
                                        document.querySelector("#registration-error-message").textContent = "";
                                        document.querySelector("#registration-error").style.display = "none";
                                    } }>
                                        <img src={ icons.google_icon }></img>
                                        <h3>GOOGLE</h3>
                                </div>
                            </div>
                            { this.state.selectedSignupMethod === "email" && <>
                                <div className={ style.signupItem }>
                                    <img alt="" src={ icons.email_orange_icon } />
                                    <input name="signup-email" id="signup-email" placeholder="Email" type="email" value={ this.state.registrationEmail } onChange={ event => {
                                        this.setState({ registrationEmail: event.target.value });
                                        document.querySelector("#registration-error").style.display = "none";
                                    } }></input>
                                </div>
                                <div className={ style.signupItem }>
                                    <img alt="" src={ icons.user_icon } />
                                    <input name="signup-username" id="signup-username" placeholder="Nome utente" type="text" value={ this.state.registrationUsername } onChange={ event => {
                                        this.setState({ registrationUsername: event.target.value });
                                        document.querySelector("#registration-error").style.display = "none";
                                    } }></input>
                                </div>
                                <div className={ style.signupItem } style={{
                                    borderBottom: this.state.registrationPassword !== this.state.registrationConfirmPassword ? "rgb(255, 0, 0) solid 1px" : "var(--orange) solid 1px"
                                }}>
                                    <img alt="" src={ icons.lock_icon } />
                                    <input name="signup-psw" id="signup-psw" placeholder="Password" type={ this.state.registrationPasswordSee ? "text" : "password" } value={ this.state.registrationPassword } onChange={ event => {
                                        this.setState({ registrationPassword: event.target.value });
                                        document.querySelector("#registration-error").style.display = "none";
                                    } }></input>
                                    <img alt="" src={ this.state.registrationPasswordSee ? icons.visibility_off_icon : icons.visibility_icon } onClick={ () => this.setState(({ registrationPasswordSee: oldRegistrationPasswordSee }) => ({ registrationPasswordSee: !oldRegistrationPasswordSee })) }></img>
                                </div>
                                <div className={ style.signupItem } style={{
                                    borderBottom: this.state.registrationPassword !== this.state.registrationConfirmPassword ? "rgb(255, 0, 0) solid 1px" : "var(--orange) solid 1px"
                                }}>
                                    <img alt="" src={ icons.lock_icon } />
                                    <input name="signup-confirm-psw" id="signup-confirm-psw" placeholder="Conferma password" type={ this.state.registrationConfirmPasswordSee ? "text" : "password" } value={ this.state.registrationConfirmPassword } onChange={ event => {
                                        this.setState({ registrationConfirmPassword: event.target.value });
                                        document.querySelector("#registration-error").style.display = "none";
                                    } }></input>
                                    <img alt="" src={ this.state.registrationConfirmPasswordSee ? icons.visibility_off_icon : icons.visibility_icon } onClick={ () => this.setState(({ registrationConfirmPasswordSee: oldRegistrationConfirmPasswordSee }) => ({ registrationConfirmPasswordSee: !oldRegistrationConfirmPasswordSee })) }></img>
                                </div> 
                            </> }
                            <div className={ style.signupItem } onClick={ () => this.state.schoolChoiceSwiper.slideNext() /*this.setState({ showSchoolSearch: !this.state.showSchoolSearch })*/ }>
                                <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                                <h3 
                                    style={{ 
                                        fontWeight: "normal",
                                        fontSize: "1rem",
                                        marginLeft: "1rem"
                                    }}>{ this.state.searchedSchools.length > 0 ? Object.values(this.state.searchedSchools).filter(school => school["miur:CODICESCUOLA"] === this.state.selectedSchool?.["miur:CODICESCUOLA"])[0]?.["miur:DENOMINAZIONESCUOLA"] : "Scuola" }
                                </h3>
                            </div>        
                            { this.state.selectedSchool &&                 
                                <div className={ style.signupItem }>
                                    <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                                    <div style={{ display: "flex" }}>
                                        <select id="class_select" value={ this.state.selectedClass ?? "Scegli una classe" } onChange={ event => this.setState({ selectedClass: event.target.value }) }>
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            { this.state.selectedSchool?.["miur:DESCRIZIONETIPOLOGIAGRADOISTRUZIONESCUOLA"] !== "SCUOLA PRIMO GRADO" && <>
                                                <option>4</option>
                                                <option>5</option>
                                            </> }
                                        </select>
                                        <input name="class_section" id="class_section" autoComplete="off" type="text" list="sections_list" placeholder="Sezione" value={ this.state.selectedClassSection } onChange={ event => this.setState({ selectedClassSection: event.target.value?.toUpperCase() }) }/>       
                                        <datalist id="sections_list">
                                            { this.state.classes && this.state.classes.filter(section => section[0] === String(this.state.selectedClass))?.map(section => {
                                                return <option key={ section }>{ section.replace(this.state.selectedClass, "") }</option>;
                                            })}
                                        </datalist>
                                    </div>
                                </div>
                            }
                            { this.state.selectedSignupMethod === "email" && <div className={ style.signupBtn } style={{ marginTop: "2rem" }} onClick={ this.signup }>{ this.state.signingUp ? <div className={ style.spinner }></div> : "REGISTRATI" }</div> }
                            { this.state.selectedSignupMethod === "google" && <div className={ style.googleBtn } 
                                style={{ marginTop: "2rem" }}
                                onClick={ this.googleSignUp }>{ 
                                    this.state.signingUp ? <div className={ style.spinner } style={{ margin: "1rem auto" }}></div> 
                                    : <>
                                        <img src={ icons.google_icon }></img>
                                        <h3>REGISTRATI</h3>
                                    </>
                                }</div>
                            }
                        </SwiperSlide>
                        <SwiperSlide>
                            <h3 className={ style.modalHeader }>PROVINCIA E COMUNE</h3>
                            <div className={ style.signupItem }>
                                <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                                <input name="select-school-region" id="select-school-region" placeholder="Provincia" type="text" value={ this.state.schoolRegion } onChange={ event => this.setState({ schoolRegion: event.target.value }) } autoComplete="off"></input>
                            </div>
                            <div className={ style.signupItem }>
                                <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                                <input name="select-school-city" id="select-school-city" placeholder="Comune" type="text" value={ this.state.schoolCity } onChange={ event => this.setState({ schoolCity: event.target.value }) } autoComplete="off"></input>
                            </div>
                            <div className={ style.signupBtn } onClick={ () => {
                                if (this.state.schoolCity || this.state.schoolRegion)
                                    this.getSchool(true);
                            } }>{ this.state.searchingSchool ? <div className={ style.spinner }></div> : "AVANTI" }</div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <h3 className={ style.modalHeader }>SCUOLA</h3>                            
                            <div className={ style.signupItem }>
                                <img alt="" src={ icons.school_icon } className={ style.inputIcon } />
                                <input name="select-school-name" id="select-school-name" placeholder="Nome scuola" type="text" value={ this.state.schoolName } onChange={ event => this.setState({ schoolName: event.target.value }) } autoComplete="off"></input>
                            </div>
                            <div className={ style.schoolChoiceContainer }>
                                { this.state.searchedSchools && this.state.searchedSchools.filter(school => school["miur:DENOMINAZIONESCUOLA"].includes(this.state.schoolName.toLowerCase().replace(new RegExp("(ipsia |iti |itis|liceo (classico |scientifico |linguistico |artistico |musicale |coreutico )*|istituto |secondaria |comprensivo |[a-z]+. )"), " ").toUpperCase().trim())).map(school => {
                                    return <div className={ style.schoolChoice } key={ school["miur:CODICESCUOLA"] } onClick={ async () => {
                                        let classes = (await getDocs(query(collection(db, `schools/${school["miur:CODICESCUOLA"]}/classes`)))).docs.map(doc => doc.id);
                                        this.setState({ selectedSchool: school, classes });
                                        this.state.schoolChoiceSwiper.slideTo(0);
                                    }}>
                                        <img alt="" src={ icons.school_icon }></img>
                                        <div>
                                            <h3>{ school["miur:DENOMINAZIONESCUOLA"] }</h3>
                                            <h4>{ school["miur:DESCRIZIONECOMUNE"] }</h4>
                                        </div>
                                    </div>;
                                }) }
                            </div>
                            <h4 className={ style.schoolNotFound } onClick={ e => {
                                e.stopPropagation();
                                this.setState({ schoolNotFoundPopup: { show: true, report: "", loading: false } }) 
                            } }>Non trovi la tua scuola?</h4>
                            {/* <h4 style={{ textAlign: "center", marginLeft: "1rem", marginRight: "1rem", fontSize: ".8rem", marginTop: "0" }}>Non trovi la tua scuola? Prova a cercare solo il nome, cancellando ad esempio "Liceo", "Itis" o simili.<br></br>Assicurati che non ci siano doppi spazi tra le parole.<br></br>Ancora nessun risultato? Segnalalo specificando il nome della tua scuola e un'email a cui inviarti eventuali aggiornamenti!</h4> */}
                        </SwiperSlide>
                    </Swiper>
                </div>
            </main>
        </>;
    }
}
